import { call, put, takeLatest } from "redux-saga/effects";
import {
  updateDeviceData,
  //fetchSuccess,
  fetchFailure,
  deviceDashboardTypes,
} from "../actions/singleDevice";
import {
  //searchEventAction,
  fetchDeviceValEndPoint,
  //fetchLocationHistorymapEndPoint,
} from "../../configuration";
import { getRandomUUID } from "../../Token";

function* fetchSaga(action) {
  try {
    const deviceResponse = yield call(fetchDeviceValueAPI, action.payload.id);
    const isBLE = deviceResponse[0].kind !== "ts.device.tgAssetTracker";

    console.log("updateDeviceData", {
      isBLE,
      deviceData: {
        name: deviceResponse[0].name,
        orgId: deviceResponse[0].customdata.orgId || null,
        organizationName:
          deviceResponse[0].customdata.organizationName || "UNKNOWN",
        siteId: deviceResponse[0].customdata.siteId || null,
        locationName: deviceResponse[0].customdata.locationName || "UNKNOWN",
        healthStatus: deviceResponse[0].customdata.healthStatus,
        connectionStatus: deviceResponse[0].customdata.connectionStatus,
        assetStatus: deviceResponse[0].customdata.assetStatus,
        activeStatus: deviceResponse[0].customdata.activeStatus,
        refid: deviceResponse[0].refid,
      },
    });
    yield put(
      updateDeviceData({
        isBLE,
        deviceData: {
          name: deviceResponse[0].name,
          orgId: deviceResponse[0].customdata.orgId || null,
          organizationName:
            deviceResponse[0].customdata.organizationName || "UNKNOWN",
          siteId: deviceResponse[0].customdata.siteId || null,
          locationName: deviceResponse[0].customdata.locationName || "UNKNOWN",
          healthStatus: deviceResponse[0].customdata.healthStatus,
          connectionStatus: deviceResponse[0].customdata.connectionStatus,
          assetStatus: deviceResponse[0].customdata.assetStatus,
          activeStatus: deviceResponse[0].customdata.activeStatus,
          refid: deviceResponse[0].refid,
        },
      })
    );
    /*
        let searchEventResponse;
        if (isBLE) {
          searchEventResponse = yield all([
            call(fetchRSSSIAPI, action.payload.id, ),
            call(fetchLocationHistorymap, action.payload)
          ]);
        }else{
          searchEventResponse = yield all([
            call(fetchRSSSIAPI, action.payload.id, ),
            call(fetchLocationHistorymap, action.payload)
          ]);
        }
    
        yield put(fetchSuccess(searchEventResponse));
        */
  } catch (error) {
    yield put(fetchFailure(error.message));
  }
}

async function fetchDeviceValueAPI(deviceId) {
  const response = await fetch(fetchDeviceValEndPoint(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      resourceidentifier: {deviceid: deviceId},
    }),
  });

  if (!response.ok) return [];

  return response.json();
}
/*
async function fetchRSSSIAPI(filter) {
  const response = await fetch(searchEventAction(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    body: JSON.stringify({
      accountname: sessionStorage.getItem("accountId"),
      $filter: `(deviceid eq '${filter.id}') AND fields containskey 'rssi' AND createdon between('${filter.startDateTime}','${filter.endDateTime}'))`,
      $sort: [{ field: "createdon", order: "desc" }],
      $pagenumber: 0,
      $limitnumber: 1,
    }),
  });

  if (!response.ok) return [];

  return response.json();
}

async function fetchLocationHistorymap(filter){
  const response = await fetch(fetchLocationHistorymapEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify({
      deviceid: filter?.id,
      startDate: filter?.startDate,
    }),
  });

  if (!response.ok) return [];

  return response.json();
}
*/
export default function* DeviceDashboardSaga() {
  yield takeLatest(deviceDashboardTypes.FETCH_REQUEST, fetchSaga);
}
